<mine-x-button (onClick)="closeDialog()"></mine-x-button>

<svg class="upgrade-plan-section__lock-icon">
    <use xlink:href="../../../assets/img/sprite.svg#close-lock"></use>
</svg>

<h1 class="mine-title-xs upgrade-plan-section__title">{{title}}</h1>

<p class="upgrade-plan-section__text" [innerHTML]="text | safe"></p>

<mine-button-primary class="upgrade-plan-section__btn mine-button-primary-lg"
                    [text]="'common.activatePortalBtn' | content"
                    (onClick)="upgradePlan()"></mine-button-primary>
